import { Welcome } from './welcome';
import { Sections, subsections } from '../../sessions.constants';
import { CheckIDs } from './check-ids';
import { OpenSession } from './open-session';
import { CloseSession } from './close-session';
import { EvaluationView } from './evaluation-view';
import { ExerciseView } from './exercise-view';
import { SessionTreatmentPlan } from './session-treatment-plan/SessionTreatmentPlan';
import { SessionMedications } from './session-medications';

const CurrentSection = ({
  selectedSection,
  selectedSubsection,
  promptsVisible,
  idFront,
  idBack,
  scratchpad,
  addScratchpadNotes,
  openEvaluationsDrawer,
  onAddEvaluation,
  currentEvaluation,
  currentBlock,
  setTextInputInFocus,
  eligibleForAutodoc,
  bodyRef,
  selectedIndex,
  leftTrigger,
  rightTrigger,
  dctPreviousResponses,
  profileElements,
  listHelper,
  exerciseHelper,
  nextGeneralAppointment,
  previousResponses,
  appointment,
  dctSelectedResponses,
  evaluationsCompleted,
  onRejectEvaluation,
  onPreviousResponseSelected,
  useAllPreviousResponses,
  treatmentPlan,
  modalities,
  expandedEvaluation,
  scrollToTop,
  setScrollToTop,
  aiMode,
  setAiMode,
}) => {
  switch (selectedSection) {
    case Sections.WELCOME:
      switch (selectedSubsection) {
        case subsections.IMPORTANT_INFORMATION:
          return <Welcome promptsVisible={promptsVisible} />;
        case subsections.DOUBLE_CHECK_IDS:
          return <CheckIDs promptsVisible={promptsVisible} idCardFront={idFront} idCardBack={idBack} />;
        case subsections.TREATMENT_PLAN:
          return <SessionTreatmentPlan promptsVisible={promptsVisible} treatmentPlan={treatmentPlan} modalities={modalities} />;
        default:
          return null;
      }
    case Sections.EVALUATIONS:
      // Check if current evaluation is an exercise
      if (currentEvaluation && currentEvaluation.type === 'EXERCISE') {
        return (
          <ExerciseView
            promptsVisible={promptsVisible}
            openEvaluationsDrawer={openEvaluationsDrawer}
            onAddEvaluation={onAddEvaluation}
            currentExercise={currentEvaluation}
            currentBlock={currentBlock}
            expandedExercise={expandedEvaluation}
            scrollToTop={scrollToTop}
            setScrollToTop={setScrollToTop}
            exerciseHelper={exerciseHelper}
            exercisesCompleted={evaluationsCompleted}
            onRejectEvaluation={onRejectEvaluation}
          />
        );
      }
      // Otherwise, render evaluation view
      return (
        <EvaluationView
          promptsVisible={promptsVisible}
          openEvaluationsDrawer={openEvaluationsDrawer}
          onAddEvaluation={onAddEvaluation}
          setTextInputInFocus={setTextInputInFocus}
          currentEvaluation={currentEvaluation}
          currentBlock={currentBlock}
          bodyRef={bodyRef}
          profileElements={profileElements}
          listHelper={listHelper}
          dctSelectedResponses={dctSelectedResponses}
          onPreviousResponseSelected={onPreviousResponseSelected}
          eligibleForAutodoc={eligibleForAutodoc}
          dctPreviousResponses={dctPreviousResponses}
          evaluationsCompleted={evaluationsCompleted}
          selectedIndex={selectedIndex}
          leftTrigger={leftTrigger}
          rightTrigger={rightTrigger}
          onRejectEvaluation={onRejectEvaluation}
          previousResponses={previousResponses}
          appointment={appointment}
          useAllPreviousResponses={useAllPreviousResponses}
          expandedEvaluation={expandedEvaluation}
          scrollToTop={scrollToTop}
          setScrollToTop={setScrollToTop}
          aiMode={aiMode}
          setAiMode={setAiMode}
        />
      );
    case Sections.MEDICATIONS:
      return (
        <SessionMedications appointment={appointment} />
      );
    case Sections.OPEN_SESSION:
      return (
        <OpenSession
          scratchpad={scratchpad}
          addScratchpadNotes={addScratchpadNotes}
          onAddEvaluation={onAddEvaluation}
        />
      );
    case Sections.CLOSE_SESSION:
      return (
        <CloseSession
          scratchpad={scratchpad}
          addScratchpadNotes={addScratchpadNotes}
          nextAppointment={nextGeneralAppointment}
        />
      );
    default:
      return null;
  }
};

export { CurrentSection };
